import Head from 'next/head';

import {HeadSEO} from '@udemy/head-seo';
import {useI18n} from '@udemy/i18n';

import {PageProps} from 'src/types/page-props';

import {useSetupNavigation} from '../../hooks/use-setup-navigation';
import {useCanonicalUrl} from '../../hooks/useCanonicalUrl';
import {META_DEFAULT_BASE_URL} from '../../lib/constants';
import {RolePlayLandingPage} from './role-play-landing-page.react-component';

export type RolePlayLandingPageFeatureProps = PageProps;

export const RolePlayLandingPageFeature: React.FC<RolePlayLandingPageFeatureProps> = (props) => {
    const {gettext} = useI18n();
    const {url: canonicalUrl} = useCanonicalUrl([], META_DEFAULT_BASE_URL);
    useSetupNavigation();

    const metaProps = {
        title: gettext('Role Play | Udemy'),
        description: gettext(
            'Meet your AI-powered conversation coach for practicing business and communication skills. Build your confidence the interactive way.',
        ),
    };

    return (
        <>
            <HeadSEO
                title={metaProps.title}
                ogTitle={metaProps.title}
                description={metaProps.description}
                ogDescription={metaProps.description}
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[props.locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
            />
            <RolePlayLandingPage {...props} />
        </>
    );
};
